import styles from "./loading.module.scss";

/**
 * ローディング コンポーネント
 * @returns {JSX.Element} ローディング コンポーネント
 */
export default function Loading() {
	return (
		<div className={styles.loading}>
			<div className={styles.wrapper}>
				<div className={styles.circle}></div>
				<div className={styles.circle}></div>
				<div className={styles.circle}></div>
				<div className={styles.shadow}></div>
				<div className={styles.shadow}></div>
				<div className={styles.shadow}></div>
			</div>
		</div>
	);
}
